import EntityListShell from "./EntityListShell";
import { TextField, TextAreaField, deText } from "./fields";
import { translateFields } from "@/lib/adminContentApi";

function slugifyClient(s) {
  return (
    (s || "")
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || "cert"
  );
}

const ICON_OPTIONS = ["ShieldCheck", "Award", "Sparkles"];

function emptyForm() {
  return { key: "", name: "", issuer: "", year: "", icon: "ShieldCheck", pdf_url: "", description: "" };
}

function toFormState(item) {
  return {
    key: item.key || "",
    name: deText(item.name),
    issuer: deText(item.issuer),
    year: item.year || "",
    icon: item.icon || "ShieldCheck",
    pdf_url: item.pdf_url || "",
    description: deText(item.description),
  };
}

async function buildPayload(form) {
  const { en = {}, fr = {} } = await translateFields({ name: form.name, issuer: form.issuer, description: form.description });
  const ml = (key, fallback) => ({ de: fallback, en: en[key] || fallback, fr: fr[key] || fallback });
  return {
    key: form.key || slugifyClient(form.name),
    name: ml("name", form.name),
    issuer: ml("issuer", form.issuer),
    year: form.year,
    icon: form.icon,
    pdf_url: form.pdf_url || null,
    description: ml("description", form.description),
  };
}

export default function CertificationsEditor() {
  return (
    <EntityListShell
      collection="certifications"
      title="Zertifikate"
      description="Deine Zertifizierungen. Reihenfolge per Pfeiltasten änderbar."
      newLabel="Zertifikat hinzufügen"
      testidBase="cert-admin"
      emptyForm={emptyForm}
      toFormState={toFormState}
      buildPayload={buildPayload}
      renderRowSummary={(item) => (
        <div>
          <div className="font-mono text-xs text-[var(--gold)]">{item.year}</div>
          <div className="text-[var(--text-0)] font-display">{deText(item.name)}</div>
          <div className="text-xs text-[var(--text-2)]">{deText(item.issuer)}</div>
        </div>
      )}
      renderFields={(form, setForm) => (
        <div className="space-y-4">
          <TextField label="Name" testid="cert-name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} required />
          <TextField label="Aussteller" testid="cert-issuer" value={form.issuer} onChange={(v) => setForm({ ...form, issuer: v })} required />
          <div className="grid grid-cols-2 gap-4">
            <TextField label="Jahr" testid="cert-year" value={form.year} onChange={(v) => setForm({ ...form, year: v })} placeholder="2024" required />
            <label className="block">
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--text-2)]">Icon</span>
              <select
                value={form.icon}
                onChange={(e) => setForm({ ...form, icon: e.target.value })}
                data-testid="cert-icon"
                className="mt-2 w-full bg-transparent border-b hairline focus:border-[var(--gold)] outline-none py-2 text-[var(--text-0)] text-sm"
              >
                {ICON_OPTIONS.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <TextField
            label="PDF-Link (optional)"
            testid="cert-pdf"
            value={form.pdf_url}
            onChange={(v) => setForm({ ...form, pdf_url: v })}
            placeholder="/cert-mein-zertifikat.pdf"
          />
          <TextAreaField
            label="Beschreibung"
            testid="cert-description"
            value={form.description}
            onChange={(v) => setForm({ ...form, description: v })}
            rows={4}
            required
          />
        </div>
      )}
    />
  );
}
